export const NO_WHITESPACE_REGEXP = /^([A-Za-z0-9_]*)$/;
